import { useRef, useState } from 'react';
import { useAiMetadataApi } from '@/features/ai-agents/shared/use-ai-metadata-api';
import { QBItemSelection } from '@/components/query-builder/models';
import { getQueryParam } from '@/utils/browser';

const AUDIENCE_AGENT = { id: `audience-builder-agent`, type: `agent` } as const;
const isLocalAi = () => getQueryParam(`local-ai`) === `1`;

export function useAudienceBuilderApi() {
  const { askQuestion } = useAiMetadataApi(isLocalAi());
  const abortControllerRef = useRef<AbortController | null>(null);
  const [loading, setLoading] = useState(false);

  const translatePrompt = async (
    prompt: string,
  ): Promise<QBItemSelection[]> => {
    abortControllerRef.current = new AbortController();
    setLoading(true);
    try {
      const result = await askQuestion(
        AUDIENCE_AGENT,
        prompt,
        abortControllerRef.current.signal,
      );
      const items = result?.content?.items ?? result?.items;
      return Array.isArray(items) ? items : [];
    } finally {
      setLoading(false);
    }
  };

  const abort = () => {
    abortControllerRef.current?.abort();
  };

  return { translatePrompt, loading, abort };
}
